export default __webpack_public_path__ + "static/media/marksman.3e628d4f.png";